import * as p from "react";
import { useCallback as g, useState as f, useEffect as w, useContext as l, useRef as x } from "react";
import { r as S, s as m } from "./useAccount-9a3d6a50.js";
import { a as y } from "./domains-6461a203.js";
import { a as h } from "./FeatureProvider-eea49aec.js";
import { H as T, N as O, b as C, T as L } from "./TranslationContext-f3729120.js";
import { g as N } from "./lodash-3345fe65.js";
import "./myasurion-shared.mixpanel.es.js";
import { g as F } from "./contentful-c6e0c83f.js";
function q(t, r) {
  const s = g(() => {
    if (typeof window > "u")
      return r;
    try {
      const n = window.localStorage.getItem(t);
      return n ? P(n) : r;
    } catch (n) {
      return console.warn(`Error reading localStorage key “${t}”:`, n), r;
    }
  }, [r, t]), [o, e] = f(s), a = S((n) => {
    typeof window > "u" && console.warn(`Tried setting localStorage key “${t}” even though environment is not a client`);
    try {
      const c = n instanceof Function ? n(o) : n;
      window.localStorage.setItem(t, JSON.stringify(c)), e(c), window.dispatchEvent(new Event("local-storage"));
    } catch (c) {
      console.warn(`Error setting localStorage key “${t}”:`, c);
    }
  });
  w(() => {
    e(s());
  }, []);
  const i = g((n) => {
    n != null && n.key && n.key !== t || e(s());
  }, [t, s]);
  return m("storage", i), m("local-storage", i), [o, a];
}
function P(t) {
  try {
    return t === "undefined" ? void 0 : JSON.parse(t ?? "");
  } catch {
    console.log("parsing error on", { value: t });
    return;
  }
}
const z = (t) => {
  var a, i;
  const r = l(h);
  if (r === void 0)
    throw new Error("useFeatureIsOn must be used within a Feature Provider");
  const s = y(), { features: o } = r, e = (i = (a = o == null ? void 0 : o.featureList) == null ? void 0 : a[s ?? "device_protection"]) == null ? void 0 : i.findIndex(
    (n) => (n == null ? void 0 : n.key) === t
  );
  return e ? e > -1 : !1;
}, K = () => {
  const t = l(T);
  if (t === void 0)
    throw new Error("useHeader must be used within a HeaderProvider");
  const { isOpen: r, setIsOpen: s, isNotifsOpen: o, setIsNotifsOpen: e, config: a } = t;
  return {
    headerIsOpen: r,
    updateHeaderIsOpen: s,
    notificationsIsOpen: o,
    updateNoficationsIsOpen: e,
    config: a
  };
}, R = (t, r) => {
  var i, n, c;
  const s = l(h);
  if (s === void 0)
    throw new Error("useDisabledFeature must be used within a Feature Provider");
  const o = y(), { features: e } = s, a = (n = (i = e == null ? void 0 : e.featureList) == null ? void 0 : i[o ?? "device_protection"]) == null ? void 0 : n.find(
    (u) => (u == null ? void 0 : u.key) === t
  );
  return (c = a == null ? void 0 : a.disabledFeatures) == null ? void 0 : c.includes(r);
}, G = () => {
  const t = l(O);
  if (t === void 0)
    throw new Error("useNotifications must be used within a Notifications Provider");
  const {
    notifications: r,
    setNotifications: s,
    isNotificationsLoading: o,
    updateClients: e,
    refetch: a,
    promptCount: i
  } = t;
  return {
    notifications: r,
    updateNotifications: s,
    isNotificationsLoading: o,
    updateClients: e,
    fetchNotifications: a,
    promptCount: i
  };
};
function D() {
}
var $ = D;
const k = /* @__PURE__ */ N($), H = k;
function Q(t, r) {
  const s = V(r, () => {
  }), o = [], e = Object.keys(r), a = Object.values(r);
  return p.Children.forEach(t, (i) => {
    if (!p.isValidElement(i)) {
      o.push(i);
      return;
    }
    const n = a.findIndex((u) => i.type === u);
    if (n === -1) {
      o.push(i);
      return;
    }
    const c = e[n];
    if (s[c]) {
      H(
        !0,
        `Found duplicate "${String(c)}" slot. Only the first will be rendered.`
      );
      return;
    }
    s[c] = i;
  }), [s, o];
}
function V(t, r) {
  return Object.keys(t).reduce((s, o) => (s[o] = r(t[o]), s), {});
}
const X = () => {
  const t = l(C);
  if (t === void 0)
    throw new Error("useTextScript must be used within a TextScriptProvider");
  const {
    language: r,
    updateActiveLanguage: s,
    module: o,
    isEnabled: e,
    updateIsEnabled: a,
    apiEnv: i,
    isEditingMode: n,
    updateIsEditingMode: c,
    isDevToolsOpen: u,
    updateIsDevToolsOpen: d,
    isDevToolsEnabled: v,
    updateIsDevToolsEnabled: E,
    isTranslationsLoading: b,
    updateIsTranslationsLoading: I
  } = t;
  return {
    language: r,
    updateActiveLanguage: s,
    module: o,
    isEnabled: e,
    updateIsEnabled: a,
    apiEnv: i,
    isEditingMode: n,
    updateIsEditingMode: c,
    isDevToolsOpen: u,
    updateIsDevToolsOpen: d,
    isDevToolsEnabled: v,
    updateIsDevToolsEnabled: E,
    isTranslationsLoading: b,
    updateIsTranslationsLoading: I
  };
}, Y = () => {
  const t = l(L);
  if (t === void 0)
    throw new Error("useLocalization must be used within a TranslationProvider");
  const {
    entries: r,
    localeLanguage: s,
    updateLocaleLanguage: o,
    getTextEntry: e,
    updateEntry: a,
    setLocalModule: i,
    isTranslationsActive: n,
    setIsTranslationsActive: c,
    translationAPI: u
  } = t;
  return {
    entries: r,
    localeLanguage: s,
    updateLocaleLanguage: o,
    getTextEntry: e,
    updateEntry: a,
    setLocalModule: i,
    isTranslationsActive: n,
    setIsTranslationsActive: c,
    translationAPI: u
  };
}, Z = () => {
  const t = x(!1);
  return [() => {
    if (typeof document > "u")
      return;
    const o = document.documentElement, { body: e } = document;
    if (!e || !e.style || t.current)
      return;
    const a = window.innerWidth - o.clientWidth, i = parseInt(window.getComputedStyle(e).getPropertyValue("padding-right")) || 0;
    o.style.position = "relative", e.style.position = "relative", o.style.overflow = "hidden", e.style.overflow = "hidden", e.style.paddingRight = `${i + a}px`, t.current = !0;
  }, () => {
    if (typeof document > "u")
      return;
    const o = document.documentElement, { body: e } = document;
    !e || !e.style || !t.current || (o.style.position = "", o.style.overflow = "", e.style.position = "", e.style.overflow = "", e.style.paddingRight = "", t.current = !1);
  }];
}, tt = (t = "", r = "", s = "", o = "", e) => {
  const [a, i] = f(null), [n, c] = f(!0);
  return w(() => {
    async function u() {
      try {
        if (t) {
          const d = await F(
            t,
            r,
            s,
            o,
            e
          );
          d && i(d);
        } else {
          i(null);
          return;
        }
      } catch (d) {
        console.error("Error fetching Contentful image:", d);
      } finally {
        c(!1);
      }
    }
    u();
  }, [t, r, s, o]), { imageUrl: a, isLoading: n };
};
export {
  z as a,
  K as b,
  R as c,
  G as d,
  Q as e,
  X as f,
  Z as g,
  tt as h,
  q as i,
  k as n,
  Y as u
};
